"use client";

import Footer from "@/components/shared/footer";
import Navbar from "@/components/shared/navbar/navbar";
import PreviewGallery from "@/components/shared/gallery/preview-gallery";
import sticker17 from "../../../public/sticker17.png";
import sticker18 from "../../../public/sticker18.png";
import LoadingScreen from "../../components/shared/loading-screen";
import { useEffect, useState } from "react";
import { fetchSessionUser } from "@/lib/authClient";
import { mapNewsArray, NewsApiResponse, NewsItem } from "@/types/news";
import ReservedEmptyState from "@/components/shared/reserved-empty-shared";
import PageVisibilityGuard from "@/components/shared/page-visibility-guard";

export default function NewsPage() {
	const [news, setNews] = useState<NewsItem[]>([]);
	const [loading, setLoading] = useState(true);
	const [showLoader, setShowLoader] = useState(true);
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		let mounted = true;

		async function refreshRole() {
			try {
				const user = await fetchSessionUser();
				if (!mounted) return;
				setIsAdmin(user?.role === "admin");
			} catch {
				if (!mounted) return;
				setIsAdmin(false);
			}
		}

		refreshRole();

		const onStorage = (e: StorageEvent) => {
			if (e.key === "logout" || e.key === "auth_session") refreshRole();
		};
		window.addEventListener("storage", onStorage);

		const onAuthChanged = () => refreshRole();
		window.addEventListener("auth:changed", onAuthChanged);

		return () => {
			mounted = false;
			window.removeEventListener("storage", onStorage);
			window.removeEventListener("auth:changed", onAuthChanged);
		};
	}, []);

	useEffect(() => {
		let alive = true;

		(async () => {
			try {
				await new Promise((res) => setTimeout(res, 600));

				const res = await fetch(
					`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/news`,
					{
						method: "GET",
						headers: { "Content-Type": "application/json" },
						cache: "no-store",
					},
				);

				if (!res.ok) throw new Error("Errore nel caricamento delle news");
				const data = (await res.json()) as NewsApiResponse[];

				if (!alive) return;

				setNews(mapNewsArray(data));
			} catch (err) {
			} finally {
				if (!alive) return;
				setLoading(false);
				setTimeout(() => setShowLoader(false), 300);
			}
		})();

		return () => {
			alive = false;
		};
	}, []);

	return (
		<PageVisibilityGuard pageKey="news">
			<>
				<LoadingScreen show={showLoader} fullscreen />
				{!loading && (
					<main className="bg-background">
						<Navbar />

						{news.length > 0 ? (
							<PreviewGallery
								title1="Scopri Tutte "
								title2="Le Novità!"
								services={news}
								leftIcon={sticker17}
								rightIcon={sticker18}
								hideIconOnMobile="left"
								isAdmin={isAdmin}
								isNews={true}
							/>
						) : (
							<ReservedEmptyState
								title="Area riservata"
								description="Nessuna news disponibile."
								buttonLabel="Torna alla home"
								href="/"
							/>
						)}

						<Footer />
					</main>
				)}
			</>
		</PageVisibilityGuard>
	);
}
